module.exports = __webpack_public_path__ + "img/chevron.0a128d9f.svg";